export const ConsumerDobFormStyles = {
  container: 'flex flex-col w-full items-center',
  errorMessage: 'my-4',
  submitButton: 'text-xl sm:text-2xl mb-8 mt-3',
}
